import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ConfirmationModal from './ConfirmationModal'
import { hideFlowError } from '../../redux/flowErrors/actions'
import moduleActions from '../../redux/modules/actions'

const ModulePlanActivation = () => {
  const flowError = useSelector((store) => store.flowErrors)
  const [modalMode, setModalMode] = React.useState('')
  const dispatch = useDispatch()

  const primaryAction = (error) => {
    if (!error) {
      if (flowError.flow.steps.length === 0) {
        if (flowError.subtype === 'add') {
          dispatch(moduleActions.add(flowError.moduleName, true)).then(() => {
            dispatch(hideFlowError())
          })
        } else {
          dispatch(moduleActions.remove(flowError.moduleName, true)).then(() => {
            dispatch(hideFlowError())
          })
        }
      } else {
        setModalMode(flowError.flow.steps[0].component)
      }
    } else {
      dispatch(hideFlowError())
      dispatch(moduleActions.add(flowError.moduleName, true))
    }
  }

  const cancelAction = () => {
    dispatch(hideFlowError())
  }

  if (!flowError.open) return null

  return (
    <div className='modal-background'>
      <ConfirmationModal
        titleKey={flowError.flow.title}
        subtitles={flowError.flow.subtitles}
        buttonTextKey={flowError.flow.buttons[0]}
        primaryAction={primaryAction}
        cancelAction={cancelAction}
        modalMode={modalMode}
      />
    </div>
  )
}

export default ModulePlanActivation